import { Button, Form, Input } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { ContainerForm } from "../styles";
import { useEffect, useRef, useState } from "react";
import { validarCodigoSMS } from "../utils/validadores";
import { SMS } from "../Interface/Sms";
import { Leads } from "../../../interfaces/Leads";

/**
 * Formulário para verificação de SMS.
 * Inclui campo de .
 * @returns Componente de formulário SMS
 */

interface FormSMSProps {
  setFormSms: (data: Partial<SMS>) => void;
  formData: Partial<Leads>;
  enviaSms: (data: Partial<SMS>) => Promise<boolean>;
  onValidChange: (isValid: boolean) => void;
}

export default function FormSMS({
  setFormSms,
  formData,
  enviaSms,
  onValidChange,
}: FormSMSProps) {
  const [form] = Form.useForm();
  const [loadings, setLoadings] = useState<boolean[]>([]);
  const [timeLeft, setTimeLeft] = useState(300);
  const [codes, setCodes] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  // Timer decrementa 1 segundo por vez
  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTimer = (seconds: number) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${String(min).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  };

  const handleChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return;

    const newCodes = [...codes];
    newCodes[index] = value.slice(-1);
    setCodes(newCodes);
    const codigo = newCodes.join("");
    setFormSms({ codigo });

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }

    const isValid = validarCodigoSMS(newCodes);

    onValidChange?.(isValid); // chama a prop, se existir
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && !codes[index] && index > 0) {
      const newCodes = [...codes];
      newCodes[index - 1] = "";
      setCodes(newCodes);
      inputsRef.current[index - 1]?.focus(); // Volta para o anterior
    }
  };

  const reenviarCodigo = (index: number) => {
    setLoadings((prev) => {
      const newLoadings = [...prev];
      newLoadings[index] = true;
      return newLoadings;
    });

    enviaSms(formData);

    // Ativa timer de 5 minutos
    setTimeLeft(5 * 60);

    // Remove o loading visual
    setTimeout(() => {
      setLoadings((prev) => {
        const newLoadings = [...prev];
        newLoadings[index] = false;
        return newLoadings;
      });
    }, 1000); // remove loading visual após 1s
  };

  return (
    <ContainerForm>
      <Form
        form={form}
        name="form-verificacao"
        layout="vertical"
        autoComplete="off"
        style={{ maxWidth: 600 }}
      >
        <Form.Item hasFeedback label="Código SMS">
          <div style={{ display: "flex", gap: "8px" }}>
            {codes.map((code, index) => (
              <Input
                key={index}
                value={code}
                maxLength={1}
                ref={(el) => (inputsRef.current[index] = el?.input || null)}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                style={{ width: 40, textAlign: "center", fontSize: 24 }}
              />
            ))}
          </div>
        </Form.Item>
      </Form>
      <Button
        type="primary"
        icon={<MessageOutlined />}
        onClick={() => reenviarCodigo(1)}
        disabled={timeLeft > 0}
        loading={loadings[1]}
      >
        {timeLeft > 0
          ? `Reenviar em ${formatTimer(timeLeft)}`
          : "Reenviar Código"}
      </Button>
    </ContainerForm>
  );
}
